import type { ColDef } from 'ag-grid-community'
import { styled } from 'styled-components'

import { FormattedMessage } from '@b-stock/fe-core/bstock-react'
import { Colors, Typography } from '@b-stock/fe-core/design-system'

export type ActiveSort = { colId: string; direction: 'asc' | 'desc' }

const Body = styled.div`
  ${Typography.Body4}
  color: ${Colors.Semantic.Neutral.very_dark_grey};
  flex-shrink: 0;
`

export const FooterRowCount = ({
  columnDefs,
  end,
  sort,
  start,
  total,
}: {
  columnDefs: ColDef[]
  end: number
  sort: ActiveSort | null
  start: number
  total: number
}) => {
  const sortLabel = sort
    ? (columnDefs.find((c) => c.field === sort.colId)?.headerName ?? null)
    : null

  return (
    <Body>
      <FormattedMessage
        id={`Listing.manifestAgGrid.rowCount.${total === 0 ? 'zero' : 'nonzero'}`}
        values={{ start, end, total }}
      />
      {total > 0 && sort && sortLabel && (
        <FormattedMessage
          id="Listing.manifestAgGrid.rowCount.sorted"
          values={{ column: sortLabel, direction: sort.direction }}
        />
      )}
    </Body>
  )
}
